import _split from 'lodash/split';
import _map from 'lodash/map';
import _reduce from 'lodash/reduce';
import _size from 'lodash/size';

/**
 * @return {object} this function parses a query string
 */
export const parseParams = queryString => {
  const queryParameters = _split(queryString, '?')[1];
  const keyValueStrings = _split(queryParameters, '&');
  const keyValuePairs = _map(keyValueStrings, keyValueString => _split(keyValueString, '='));
  return _reduce(keyValuePairs, (result, pair) => (_size(pair) === 2 ? ({ ...result, [pair[0]]: pair[1] }) : result), {});
};

/**
 * @return {string} this stringifies an object into a query string
*/
export const stringifyParams = params => _reduce(params, (queryString, value, key) => {
  if (!value) {
    return queryString;
  }
  const joinChar = !queryString ? '?' : '&';
  return `${queryString}${joinChar}${key}=${value}`;
}, '');

/* Should be updated if consultation url changes */
export const getUrlWithoutLoginDetails = ({ origin, pathname, search }) => {
  const { codeName, twmid } = parseParams(search);
  const query = stringifyParams({ codeName, twmid });
  return `${origin}${pathname}${encodeURIComponent(query)}`;
};
